import React, { useEffect, useState, useRef, useMemo } from "react";
import DataTable from "react-data-table-component";
import { apiAxios } from "../../utils/apiAxios";
import "../../style/RaiseTicket.css";
import { toast } from "react-toastify";
import Select from "react-select";

const API_BASE = process.env.REACT_APP_API_BASE_URL;
const API_PATH = process.env.REACT_APP_API_PATH_URL;

const APITicket = `${API_BASE}/Ticket`;
const APITicketType = `${API_BASE}/TicketType`;
//const APITicketPriority = `${API_BASE}/TicketPriority`;
const APIDentistCase = `${API_BASE}/Dentist`;

const RaiseTicket = () => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const chatEndRef = useRef<any>(null);
  const [showCaseModal, setShowCaseModal] = useState(false);
  // const [selectedCase, setSelectedCase] = useState<any>(null);
  const [tickets, setTickets] = useState<any[]>([]);
  const [ticketTypes, setTicketTypes] = useState<any[]>([]);
  //const [ticketPriorities, setTicketPriorities] = useState<any[]>([]);
  const [dentistCases, setDentistCases] = useState<any[]>([]);
  const [caseId, setCaseId] = useState<number | null>(null);

  // ✅ Searchable dropdown options derived from dentistCases (declared ONCE, right after the state it depends on)
  // const caseOptions = useMemo(
  //   () =>
      
  //     dentistCases.map((c: any) => ({
  //       value: c.caseID,
  //       label: `TZ${c.caseID}${c.patientName ? ` - ${c.patientName}` : ""}`,
  //     })),
     
  //   [dentistCases]
  // );

  const caseOptions = useMemo(
  () =>
    [...dentistCases]
      .sort(
        (a: any, b: any) =>
          new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime()
      )
      .map((c: any) => ({
        value: c.caseID,
        label: `TZ${c.caseID} - ${new Date(c.createdDate).toLocaleDateString(
          "en-GB"
        )}`,
      })),
  [dentistCases]
);
  const [caseInfo, setCaseInfo] = useState<any>(null);
  const [toothList, setToothList] = useState<any[]>([]);
  const [selectedTicket, setSelectedTicket] = useState<any>(null);
  const [replies, setReplies] = useState<any[]>([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [form, setForm] = useState({
    ticketType: "",
    priority: "",
    subject: "",
    description: "",
    file: null as File | null,
  });
const ticketTypeOptions = ticketTypes.map((t: any) => ({
  value: t.ticketTypeName,
  label: t.ticketTypeName,
}));
  const [replyForm, setReplyForm] = useState({
    message: "",
    file: null as File | null,
  });

  // ---------------- LOAD DATA ----------------
  const loadTickets = async () => {
    const selectedClinic = JSON.parse(sessionStorage.getItem("selectedClinic") || "{}");
    const res = await apiAxios.get(`${APITicket}/GetClinicTickets/${selectedClinic.clinicID}`);
    // console.log("GetClinicTickets API Response:", res);
    // console.log("GetClinicTickets Data:", res.data);
    setTickets(res.data);
  };

  const loadReplies = async (ticketId: number) => {
    const res = await apiAxios.get(`${APITicket}/${ticketId}/messages`);

    setReplies(
      res.data.map((x: any) => ({
        id: x.messageID,
        message: x.message,
        file: x.attachmentPath,
        senderType: x.senderType,
        date: new Date(x.createdDate).toLocaleString("en-GB"),
      }))
    );
  };

  const loadCasesByType = async (ticketType: string) => {
    const selectedClinic = JSON.parse(
      sessionStorage.getItem("selectedClinic") || "{}"
    );

    try {
      let res;

      if (ticketType === "Claim Warranty") {
        // NEW API FOR COMPLETED CASES
        res = await apiAxios.post(
          `${APIDentistCase}/GetCompletedCasesDashBoard`,
          { clinicId: selectedClinic.clinicID }
        );
      } else {
        // EXISTING API
        res = await apiAxios.post(
          `${APIDentistCase}/GetAllCasesDashBoard`,
          { clinicId: selectedClinic.clinicID }
        );
      }

      setDentistCases(res.data?.singleData || res.data || []);
      // console.log("singleData:", res.data?.singleData);
      // console.log("Full Response:", res.data);

      setCaseId(null);
    } catch (error) {
      console.error(error);
    }
  };

  const loadMasters = async () => {
    const selectedClinic = JSON.parse(sessionStorage.getItem("selectedClinic") || "{}");
    const t = await apiAxios.get(`${APITicketType}/GetActiveAll`);
    // const p = await apiAxios.get(`${APITicketPriority}/GetAllActive`);
    const c = await apiAxios.post(`${APIDentistCase}/GetAllCasesDashBoard`,
      selectedClinic.clinicID ? { clinicId: selectedClinic.clinicID } : {},);

    setTicketTypes(t.data.data);
    // setTicketPriorities(p.data);
    setDentistCases(c.data?.singleData || c.data || []);
  };

  useEffect(() => {
    loadTickets();
    loadMasters();
  }, []);

  // ---------------- CHAT ----------------
  const openChat = async (row: any) => {
    setSelectedTicket(row);

    // 🔥 RESET REPLY FORM
    setReplyForm({
      message: "",
      file: null
    });

    // 🔥 CLEAR FILE INPUT
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    await loadReplies(row.ticketID);
  };

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [replies]);


  // ---------------- CREATE TICKET ----------------
  const submitTicket = async () => {
    if (!form.ticketType || !form.subject || !caseId) {
      toast.error("Fill required fields");
      return;
    }

    try {
      setIsSubmitting(true);

      const selectedClinic = JSON.parse(
        sessionStorage.getItem("selectedClinic") || "{}"
      );
      const user = JSON.parse(sessionStorage.getItem("user") || "{}");

      const fd = new FormData();
      fd.append("CaseID", caseId.toString());
      fd.append("TicketType", form.ticketType);
      fd.append("Subject", form.subject);
      fd.append("Description", form.description);
      fd.append("SenderType", user?.roleName || "Dentist");
      fd.append("ClinicID", selectedClinic.clinicID);

      if (form.file) fd.append("file", form.file);

      await apiAxios.post(APITicket, fd);

      toast.success("Ticket Created");

      setForm({
        ticketType: "",
        priority: "",
        subject: "",
        description: "",
        file: null,
      });

      setCaseId(null);

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }

      await loadTickets();
    } catch (error) {
      console.error(error);
      toast.error("Failed to create ticket");
    } finally {
      setIsSubmitting(false);
    }
  };

  // ---------------- SEND REPLY ----------------
  const sendReply = async () => {
    // if (!replyForm.message.trim()) return;
    if (!replyForm.message.trim() && !replyForm.file) return;
    const user = JSON.parse(sessionStorage.getItem("user") || "{}");

    const fd = new FormData();
    fd.append("TicketID", selectedTicket.ticketID);
    fd.append("Message", replyForm.message);
    fd.append("SenderType", user?.roleName || "Dentist");

    if (replyForm.file) fd.append("file", replyForm.file);

    await apiAxios.post(`${APITicket}/message`, fd);

    setReplyForm({ message: "", file: null });
    await loadReplies(selectedTicket.ticketID);
  };

  const openCaseDetail = async (caseId: number) => {
    try {
      const res = await apiAxios.post(`${APIDentistCase}/GetReuploadScanDetail`, { CaseID: caseId });

      const data = res.data.singleData || res.data; // ✅ Adjust based on API response

      if (!data || data.length === 0) return;

      // ✅ First item = case info
      setCaseInfo(data[0]);

      // ✅ Full list = tooth details
      setToothList(data);

      setShowCaseModal(true);

    } catch (err) {
      console.error(err);
      toast.error("Failed to load case");
    }
  };
  const formatDateTime = (dateString: string) => {
    if (!dateString) return "-";

    return new Date(dateString).toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true
    });
  };


  const claimWarrantyTickets = tickets.filter(
    (t: any) =>
      t.ticketType === "Claim Warranty" ||
      t.ticketType === "claim_warranty"
  );

  const otherTickets = tickets.filter(
    (t: any) =>
      t.ticketType !== "Claim Warranty" &&
      t.ticketType !== "claim_warranty"
  );

  const claimWarrantyColumns = [
    {
      name: "Ticket",
      selector: (row: any) => row.ticketNumber,
      cell: (row: any) => (
        <span title={String(row.ticketNumber)}>
          {row.ticketNumber}
        </span>
      ),
    },
    {
      name: "Warranty Status",
      cell: (r: any) => (
        <span
          className={`badge raise-ticket-badge ${r.ticketStatus === "Rejected"
              ? "bg-danger"
              : r.ticketStatus === "PENDING"
                ? "bg-warning text-dark"
                : r.ticketStatus === "APPROVED"
                  ? "bg-success"
                  : "bg-secondary"
            }`}
        >
          {r.ticketStatus || "-"}
        </span>
      ),
      minWidth: "180px"
    },

    {
      name: "Case",
      cell: (row: any) => (
        <span
          style={{ color: "#0d6efd", cursor: "pointer", fontWeight: 500 }}
          onClick={() => openCaseDetail(row.caseID)}
        >
          TZ{row.caseID}
        </span>
      )
    },

    {
      name: "Type",
      selector: (row: any) => row.ticketType || "-",
      minWidth: "180px"
    },

    {
      name: "Chat",
      cell: (row: any) => (
        <button
          className="btn btn-sm btn-success"
          onClick={() => openChat(row)}
        >
          Open
        </button>
      )
    }
  ];

  const otherTicketColumns = [
    {
      name: "Ticket",
      minWidth: "160px",
      selector: (r: any) => r.ticketNumber, // keeps sorting/filtering
      cell: (row: any) => (
        <span title={row.ticketNumber}>
          {row.ticketNumber}
        </span>
      ),
    },

    {
      name: "Status",
      cell: (r: any) => (
        <span
          title={r.ticketStatus}
          className={`badge raise-ticket-badge ${r.ticketStatus === "Closed"
              ? "bg-danger"
              : r.ticketStatus === "Pending"
                ? "bg-warning text-dark"
                : "bg-success"
            }`}
          style={{
            display: "inline-block",
            maxWidth: "140px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {r.ticketStatus}
        </span>
      ),
      minWidth: "160px",
    },

    {
      name: "Case",
      cell: (row: any) => (
        <span
          style={{ color: "#0d6efd", cursor: "pointer", fontWeight: 500 }}
          onClick={() => openCaseDetail(row.caseID)}
        >
          TZ{row.caseID}
        </span>
      )
    },

    {
      name: "Type",
      selector: (row: any) => row.ticketType || "-",
      minWidth: "180px"
    },

    {
      name: "Chat",
      cell: (row: any) => (
        <button
          className="btn btn-sm btn-success"
          onClick={() => openChat(row)}
        >
          Open
        </button>
      )
    }
  ];

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12">

          <h5 className="mb-3 raise-ticket-heading">Raise Ticket</h5>
          {/* ---------------- FORM ---------------- */}
          <div className="premium-card mb-4">
            <div className="row g-2">
          <div className="col-md-12 col-lg-3 col-sm-12">
  <label className="form-label">
    Select Type <span className="required">*</span>
  </label>

  <Select
    options={ticketTypeOptions}
    value={
      ticketTypeOptions.find(
        (opt) => opt.value === form.ticketType
      ) || null
    }
    onChange={(selectedOption) => {
      const selectedType = selectedOption
        ? selectedOption.value
        : "";

      setForm({
        ...form,
        ticketType: selectedType,
      });

      loadCasesByType(selectedType);
      setCaseId(null); // Optional: clear selected case when type changes
    }}
    placeholder="Select Type"
    isClearable
    isSearchable
    classNamePrefix="react-select"
  />
</div>

              <div className="col-md-12 col-lg-3 col-sm-12">
                <label className="form-label">
                  Select Case <span className="required">*</span>
                </label>
                <Select
                  options={caseOptions}
                  value={caseOptions.find((opt) => opt.value === caseId) || null}
                  onChange={(selectedOption) =>
                    setCaseId(selectedOption ? Number(selectedOption.value) : null)
                  }
                  placeholder="Select Case"
                  isClearable
                  isSearchable
                  classNamePrefix="react-select"
                />
              </div>

              <div className="col-md-12 col-lg-3 col-sm-12">
                <label className="form-label">Enter Subject <span className="required">*</span></label>
                <input className="form-control"
                  placeholder="Subject"
                  value={form.subject}
                  onChange={(e) => setForm({ ...form, subject: e.target.value })} />
              </div>
              <div className="col-md-12 col-lg-3 col-sm-12">
                <label className="form-label">Upload File</label>
                <input type="file"
                  ref={fileInputRef}
                  className="form-control"
                  onChange={(e: any) =>
                    setForm({ ...form, file: e.target.files[0] })}
                />
              </div>
              <div className="col-md-12 mt-2">
                <label className="form-label">Description</label>
                <textarea className="form-control"
                  placeholder="Description"
                  rows={4}
                  value={form.description}
                  onChange={(e) => setForm({ ...form, description: e.target.value })} />
              </div>

              <div className="col-md-6 mt-3">
                <button
                  className="btn btn-primary"
                  onClick={submitTicket}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Submitting...
                    </>
                  ) : (
                    "Submit Ticket"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ---------------- MAIN SECTION ---------------- */}
      <div className="row">

        {/* LEFT TABLE */}
        <div className="col-md-5">

          {/* CLAIM WARRANTY TICKETS */}
          <div className="premium-card mb-4">
            <h6 className="mb-2">Claim Warranty Tickets</h6>

            <DataTable
              columns={claimWarrantyColumns}
              data={claimWarrantyTickets}
              pagination
              paginationPerPage={5}
              fixedHeader
              paginationComponentOptions={{
                noRowsPerPage: true
              }}
              fixedHeaderScrollHeight="220px"
              dense
              noDataComponent="No claim warranty tickets found"
            />
          </div>

          {/* OTHER TICKETS */}
          <div className="premium-card mb-4">
            <h6 className="mb-2">Other Tickets</h6>

            <DataTable
              columns={otherTicketColumns}
              data={otherTickets}
              pagination
              paginationPerPage={5}
              fixedHeader
              paginationComponentOptions={{
                noRowsPerPage: true
              }}
              fixedHeaderScrollHeight="220px"
              dense
              noDataComponent="No other tickets found"
            />
          </div>

        </div>

        {/* RIGHT CHAT */}
        <div className="col-md-7">
          <div className="chat-container premium-card chat-card shadow-sm">

            {/* HEADER */}
            <div className="chat-header d-flex justify-content-between align-items-center">
              <span>
                {selectedTicket
                  ? `Ticket - ${selectedTicket.ticketNumber}`
                  : "Select a ticket"}
              </span>
            </div>

            {/* BODY */}
            <div className="chat-body">

              {replies.length === 0 && (
                <div className="text-center text-muted mt-3">
                  No messages
                </div>
              )}

              {replies.map((msg) => {
                const hasMessage = msg.message?.trim();
                const hasFile = msg.file && msg.file !== "";

                // 🚀 THIS LINE FIXES YOUR ISSUE
                if (!hasMessage && !hasFile) return null;
                const isSent = msg.senderType === "Dentist";
                const isUnread = !msg.seen && !isSent;

                return (
                  <div
                    key={msg.id}
                    className={`chat-message ${isSent ? "sent" : "received"} ${isUnread ? "unread" : ""}`}
                  >

                    <div className="chat-bubble">

                      {/* MESSAGE */}
                      {msg.message?.trim() && <div>{msg.message}</div>}

                      {/* FILE */}
                      {msg.file && (
                        msg.file.match(/\.(jpeg|jpg|png|gif)$/) ? (
                          <img
                            src={`${API_PATH}${msg.file}`}
                            alt="img"
                            className="chat-img"
                          />
                        ) : (
                          <a
                            href={`${API_PATH}${msg.file}`}
                            target="_blank"
                            rel="noreferrer"
                            className="chat-file"
                          >
                            📎 File
                          </a>
                        )
                      )}

                      {/* DATE (ONLY IF MSG OR FILE EXISTS) */}
                      {(msg.message?.trim() || msg.file) && (
                        <div className="chat-meta">
                          <span className="chat-time-hover">
                            {msg.date}
                          </span>
                        </div>
                      )}

                    </div>
                  </div>
                );
              })}

              <div ref={chatEndRef}></div>
            </div>

            {/* CLOSED */}
            {selectedTicket &&
              (selectedTicket.ticketStatus?.toUpperCase() === "CLOSED" ||
                selectedTicket.ticketStatus?.toUpperCase() === "REJECTED") && (
                <div className="chat-closed">
                  🔒 This ticket is closed
                </div>
              )}

            {/* FOOTER */}
            {selectedTicket &&
              selectedTicket.ticketStatus?.toUpperCase() !== "CLOSED" &&
              selectedTicket.ticketStatus?.toUpperCase() !== "REJECTED" && (

                <div className="chat-footer">

                  {/* INPUT ROW */}
                  <div className="chat-input-row">

                    {/* INPUT */}
                    <div className="chat-input-wrapper position-relative">

                      <input
                        type="text"
                        className="form-control chat-input"
                        placeholder="Type a message..."
                        value={replyForm.message}
                        onChange={(e) =>
                          setReplyForm({ ...replyForm, message: e.target.value })
                        }
                        onKeyDown={(e) => {
                          if (e.key === "Enter" && replyForm.message.trim()) {
                            e.preventDefault();
                            sendReply();
                          }
                        }}
                      />

                    </div>

                    {/* FILE */}
                    <input
                      type="file"
                      hidden
                      id="fileUpload"
                      onChange={(e: any) =>
                        setReplyForm({ ...replyForm, file: e.target.files[0] })
                      }
                    />

                    <label htmlFor="fileUpload" className="icon-btn">
                      <i className="bi bi-paperclip"></i>
                    </label>

                    {/* SEND */}
                    <button className="send-btn" onClick={sendReply}>
                      <i className="bi bi-send-fill"></i>
                    </button>

                  </div>

                  {/* FILE PREVIEW */}
                  {replyForm.file && (
                    <div className="file-preview">

                      {replyForm.file.type.startsWith("image/") ? (
                        <img
                          src={URL.createObjectURL(replyForm.file)}
                          alt="preview"
                          className="preview-img"
                        />
                      ) : (
                        <span>📎 {replyForm.file.name}</span>
                      )}

                      <i
                        className="bi bi-x-circle-fill remove-file"
                        onClick={() =>
                          setReplyForm(prev => ({ ...prev, file: null }))
                        }
                      ></i>
                    </div>
                  )}

                </div>
              )}

          </div>
        </div>

      </div>
      {showCaseModal && (
        <div className="custom-modal-overlay">
          <div className="custom-modal">

            <div className="modal-header">
              <h5>Case Details</h5>
              <button onClick={() => setShowCaseModal(false)} className="custom-close-btn btn-close raise-ticket-closebtn"><i className="bi bi-x customcross"></i></button>

            </div>

            <div className="modal-body">

              {/* 🔹 CASE INFO */}
              {caseInfo && (
                <div className="mb-3 border-bottom pb-2">
                  <div className="carse-id-text"><strong>Case ID:</strong> TZ{caseInfo.caseID}</div>
                  <div className="carse-id-text"><strong>Patient:</strong> {caseInfo.patientName}</div>
                  <div className="carse-id-text">
                    <strong>Status:</strong>
                    <span className="badge bg-warning ms-2">
                      {caseInfo.dentistTag}
                    </span>
                  </div>
                  <div className="carse-id-text">
                    <strong>ETA:</strong> {formatDateTime(caseInfo.expectedEta)}
                  </div>

                </div>
              )}

              {/* 🔹 TOOTH TABLE */}
              <div>
                <h6>Tooth Details</h6>

                <table className="table table-bordered table-sm">
                  <thead className="table-light">
                    <tr>
                      <th>Tooth No</th>
                      <th>Shade</th>
                      <th>Material</th>
                    </tr>
                  </thead>
                  <tbody>
                    {toothList.map((t, i) => (
                      <tr key={i}>
                        <td>{t.toothNumber}</td>
                        <td>{t.shade}</td>
                        <td>{t.materialName}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

            </div>

          </div>
        </div>
      )}
    </div>
  );
};

export default RaiseTicket;
